import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const BtnNav = (props) => {
  const { titre, icone, lien } = props;
  const navigate = useNavigate();
  useEffect(() => {
    if (lien == "logout") {
      //window.localStorage.clear();
      navigate("/login");
    }
  }, []);

  return (
    <div className="">
      <div className="d-grid gap-2">
        <Link to={lien}>
          <button
            class="btn text-start btn-navigation btn-link w-100 pb-0 mt-2"
            type="button"
          >
            <span></span>
            {icone} <span className='btn-nav-name"'>{titre}</span>
          </button>
        </Link>
      </div>
    </div>

    // **************************************************************************************//

    // <div className=''>
    //     <div className="d-grid gap-2">
    //         <button class="btn text-start btn-link w-100 pb-0 mt-2" type="button" data-bs-toggle="collapse" data-bs-target={"#"+id} aria-expanded="false" aria-controls={id}>
    //         {icone} {titre}
    //         </button>
    //         <div class="collapse text-start BtnNavSous " id={id}>
    //             <div>
    //                 <Link to={lienForm}>
    //                     <button className='btn py-0 btn-link '>Ajouter</button>
    //                 </Link>
    //             </div>
    //             <div>
    //                 <Link to={lienList}>
    //                     <button className='btn py-0 btn-link'>Liste</button>
    //                 </Link>
    //             </div>
    //         </div>
    //     </div>
    // </div>
  );
};

export default BtnNav;
